import React, { PureComponent } from 'react';
import { Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { EnterpriseLogin, Processing } from 'cloak-file-sdk-web'

import { modalStyles } from '../styles/styles'

const modalStyle = modalStyles.singleLineModal

class EnterpriseLoginPage extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            email: '',
            userid: '',
            password: '',
            otp: '',
            emailError: false,
            useridError: false,
            passError: false,
            otpError: false,
        }
    }

    componentDidMount() {
    }

    render() {
        const { intl } = this.props
        const { verifiedUser, gwyAuthInProgress, token, info } = this.props;

        var url = new URL(window.location.href)
        console.log("url " + url)
        var email = url.searchParams.get("email")
        console.log("email " + email)
        var error = url.searchParams.get("error")
        console.log("error " + error)
        if (error === '0') {
            error = 'emailVerified'
        } else if (error === '1') {
            error = 'emailNotVerified'
        } else if (error === '10') {
            error = 'emailMigrated'
        } else if (error === '11') {
            error = 'emailNotMigrated'
        }

        if (token) {
            if (Object.values(info).length > 0) {

                if (info.mode === 'uncloak') {
                    return <Navigate to="/cloak/uncloak" />
                }
            }

            return <Navigate to="/cloak/cloak" />
        }

        if (verifiedUser === false) {
            // Mark this as a gateway/enterprise verification in the URL (survives reloads and the
            // redux userInfo being reset by other login sagas), so VerifyPage routes back here
            // (enterprise login) after verification instead of the password login page.
            return <Navigate to="/cloak/verify-email?gwy=true" />
        }

        return (
            <div className="clk-primary-console-div">
                <div className="clk-primary-console clk-box-shadow " style={{ height: 640 }}>
                    <div className="clk-login-div">
                        <Processing show={gwyAuthInProgress} processing={gwyAuthInProgress} style={modalStyle} message='login.loginInProgress' />
                        <div className="clk-main-title-div">
                            <div className="clk-main-title-text">
                                <FormattedMessage id="login.enterpriseTitle" />
                            </div>
                        </div>
                        <EnterpriseLogin emailLabel={intl.formatMessage({ id: 'login.email' })}
                            useridLabel={intl.formatMessage({ id: 'login.userid' })}
                            pwdLabel={intl.formatMessage({ id: 'login.password' })}
                            otpLabel={intl.formatMessage({ id: 'login.OTP' })}
                            actionTitle={intl.formatMessage({ id: 'login.title' })}
                            email="{email}"
                            error={error} />
                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        gwyAuthInProgress: state.auth.gwyAuthInProgress,
        verifiedUser: state.auth.verifiedUser,
        token: state.auth.token,
        info: state.cloak.info,
    }
};

export default connect(mapStateToProps)(injectIntl(EnterpriseLoginPage));
